export default __webpack_public_path__ + "static/media/orange-ray.d01eb0aa.svg";